import {
  DecorationCategory,
  DecorationCategoryMap,
} from '@/models/decorationCategories'

export function getDecorationCategoryMap(
  decorationCategories: DecorationCategory[]
): DecorationCategoryMap {
  return decorationCategories.reduce<DecorationCategoryMap>((acc, category) => {
    category.decorations.forEach((decoration) => {
      acc[decoration.name] = decoration.image
    })
    return acc
  }, {})
}
